import React, { useEffect, useState } from "react";
import { TablePagination } from "../../../components/table";
import EventItem from '../components/EventItem/EventItem'
import { useDebounce } from "use-debounce";
import { pastEventList } from "./slice/pastEventAction";
import { useDispatch, useSelector } from "react-redux";
import LocalStorage from "../../../hook/LocalStorage";
import ScreenLoader from "../../../components/Loader/ScreenLoader";
import { setLoadedEvent, setLoadingEvent, setLoadingContent, pastEventItemList, setDuplicateEvent } from './slice/pastEventSlice'
import DuplicateForm from "../components/Modal/DuplicateForm";
import { useHistory, useParams } from "react-router-dom";
import DeleteModal from "../components/Modal/DeleteModal";
import MediaDownloadPublicLink from "../components/Modal/MediaDownloadPublicLink";


const TablePast = () => {
  const dispatch = useDispatch();
  const { data, current_page, total, per_page, from, to } = useSelector(
    (state) => state.pastEvent.pastEvent
  );

  const { isLoading, loadedEvent, loadingEvent, loadingContent, duplicateEvent } = useSelector((state) => state.pastEvent);
  const [filterPerPage, setFilterPerPage] = useState(6);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [searchKeyWordDebounce] = useDebounce(searchKeyWord, 1000);
  const { user } = LocalStorage()
  const history = useHistory()
  const { type } = useParams()
  const handleSearch = (query) => {
    setSearchKeyWord(query);
    setCurrentPage(1);
  };

  const handelFilterPerPage = (perPage) => {
    setCurrentPage(1);
    setFilterPerPage(perPage);
  };
  // const params = {
  //   per_page: filterPerPage,
  //   user_id: user.id,
  //   page: currentPage,
  //   search: searchKeyWordDebounce
  // };
  const param = history.location.search;
  useEffect(() => {
    dispatch(pastEventList(param));
  }, [param, filterPerPage, currentPage, searchKeyWordDebounce]);

  const cardStyle = {
    backgroundImage: `url("https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80")`
  }

  return (
    <>

      <div className="row">
        {!isLoading ?
          data &&
            data.length > 0 ?
            data.map((res) => {
              return (
                <div className="col-md-6 col-lg-4 col-xl-4" key={res.id}>
                  <EventItem
                    targetModalId={"past-modal"}
                    removeModalId={"past-modal-remove"}
                    mediaDownloadPubliclink={"past-modal-download-link"}
                    item={res}
                    setDuplicateEvent={setDuplicateEvent}
                    eventType={"past"}
                    per_page={filterPerPage}
                    page={currentPage}
                    user_id={user.id}
                    search={searchKeyWordDebounce}
                  />
                </div>
              );
            })
            :
            <div className="col-12">
              <div className="empty-event">
                <div className="empty-event-content">
                  <h4 className="empty-event-title">No Events Found</h4>
                </div>
              </div>
            </div>
          :
          <div className="col-12">
            <div className="empty-event">
              <div className="empty-event-content">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>

        }
      </div>

      {
        loadingEvent &&
        <ScreenLoader loadingContent={loadingContent} loaded={loadedEvent} />
      }

      <DuplicateForm
        modalId={"past-modal"}
        setLoadedEvent={setLoadedEvent}
        setLoadingEvent={setLoadingEvent}
        setLoadingContent={setLoadingContent}
        duplicateEvent={duplicateEvent}
        fetchItemList={pastEventItemList}
      />

      <MediaDownloadPublicLink 
				modalId={"past-modal-download-link"}
				selectedUuid={duplicateEvent?.uuid}
			/>

      <DeleteModal
				modalId={"past-modal-remove"}
				selectedItem={duplicateEvent}
				setLoadedEvent={setLoadedEvent}
				setLoadingEvent={setLoadingEvent}
				setLoadingContent={setLoadingContent}
			/>

      <TablePagination
        currentPage={current_page}
        total={total}
        perPage={per_page}
        from={from}
        to={to}
        onChange={(page) => history.push({
          hash: '#past',
          search: `?page=${page}&user_id=${user.id}&per_page=${6}`,
        })}
      />
    </>
  );
};

export default TablePast;
